import { ITrend } from '@/models/dashboard.model';

export const normalizeDashboardTrends = (startData: ITrend[], fullTrendsList: ITrend[]) => {
  const filtered = fullTrendsList.filter(
    (item) => !startData.find((startDataItem) => startDataItem.name === item.name),
  );

  return [...startData, ...filtered];
};
